module.exports = __webpack_public_path__ + "static/media/covi_mee_rem_mee.79e001f7.png";